// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e7795985","239":"41369423","453":"01a19c94","455":"04896441","885":"b2bd7b6c"}[chunkId] + ".chunk.js";
};